import { render } from "./Agreement.vue?vue&type=template&id=000413f1&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=000413f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-000413f1"

export default script